/**
 * Route constant list
 */
export const CONST_ROUTE_PATH = {
    ABOUT: '/about',
    PRODUCTS: '/products',
    SERVICES: '/services',
    BLOGS: '/blogs',
    SCHEDULE_MEETING: '/appointment-booking',
    QUERY_LOGS: '/query-logs',
    CONTACT_US: '/contact-us',
    CLOUD_ESTIMATOR: '/cloud-estimator',
    TERMS_CONDITIONS: '/terms-and-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    REFUND_POLICY: '/refund-policy',
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    MY_PROFILE: '/my-profile',
    VERIFY_EMAIL: '/verify-email',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    ONBOARD_REQUEST: '/onboard-request',
    PAGE_NOT_FOUND: '/page-not-found',
    ADD_ACCOUNT: '/add-account',
    DASHBOARD: '/dashboard',
    DASHBOARD_CAPTURE: '/dashboard-capture',
    // PAYMENT: '/payment',
    RESPONSE_HANDLER: '/response-handler',
    THANK_YOU: '/thank-you',
    PAYMENT_FAILED: '/payment-failed',
    PRICING: '/pricing',
    CHAT_PDF: '/chatpdf',
    DATA_CENTRE_COST_CALCULATOR: '/data-centre-cost-calculator',
    OPTIMIZATION: {
        BASE: '/optimization',
        BIQ_QUERY: '/optimization/big-query',
        COMPUTE_ENGINE: '/optimization/compute-engine',
        CLOUD_SQL: '/optimization/cloud-sql',
        CLOUD_RUN: '/optimization/cloud-run',
        EC2: '/optimization/ec2',
        ECS: '/optimization/ecs',
        EBS: '/optimization/ebs',
        LAMBDA: '/optimization/lambda',
        RDS: '/optimization/rds',
        S3: '/optimization/s3',
        ASG: '/optimization/asg',
        ELASTIC_IP: '/optimization/elastic-ip',
        EBS_SNAPSHOT: '/optimization/ebs-snapshot',
        RDS_SNAPSHOT: '/optimization/rds-snapshot',
        ROI: '/optimization/roi',
        VIRTUAL_MACHINE: '/optimization/vm',
        MANAGED_DISKS: '/optimization/managed-disks',
        MANAGED_DISKS_SNAPSHOT: '/optimization/managed-disk-snapshot',
        BLOB_STORAGE: '/optimization/blob-storage',
        VM_SCALE_SET: '/optimization/vm-scale-set',
        CONTAINER_INSTANCE: '/optimization/container-instance',
        PUBLIC_IP: '/optimization/public-ip',
        AZURE_ROI: '/optimization/az-roi',
        AZURE_WEB_APP: '/optimization/web-app',
        AZURE_STATIC_WEB_APP: '/optimization/static-web-app',
        AZURE_DB_MYSQL: '/optimization/db/mysql',
        AZURE_DB_POSTGRESSQL: '/optimization/db/postgresql',
        AZURE_DB_SQL: '/optimization/db/sql',
    },
    INVENTORY: {
        BASE: '/inventory',
        REPORTS: '/inventory/reports',
        EC2: '/inventory/ec2',
        ECS: '/inventory/ecs',
        EBS: '/inventory/ebs',
        LAMBDA: '/inventory/lambda',
        RDS: '/inventory/rds',
        S3: '/inventory/s3',
        ASG: '/inventory/asg',
        SAVING_COST: '/inventory/saving-cost',
        GLOBAL_SCAN: '/inventory/global-scan',
        CLOUD_ESTIMATOR: '/inventory/cloud-estimator',
        VIRTUAL_MACHINE: '/inventory/vm',
        VIRTUAL_MACHINE_SS: '/inventory/vm-scale-set',
        AZURE_REPORTS: '/inventory/azure/reports',
        AZURE_DB_MYSQL: '/inventory/db/mysql',
        AZURE_DB_POSTGRESSQL: '/inventory/db/postgresql',
        AZURE_DB_SQL: '/inventory/db/sql',
        TAG_START_STOP: '/inventory/tag-based-action',
    },
    DEVOPS: {
        BASE: '/devops',
        SETUP_INFRASTRUCTURE: '/devops/setup-infrastructure',
        MANAGE_SERVICE: '/devops/manage-service',
        EXECUTE_CUSTOM_COMMANDS: '/devops/execute-custom-commands',
        MONITORING: '/devops/monitoring',
    },
    SECURITY: {
        BASE: '/security',
        ACCOUNT_SCAN: '/security/account-scan',
        ACCOUNT_SCAN_RESULT: '/security/account-scan-result',
    },
    BILLING: {
        BASE: '/billing',
        CLOUD_COST_CONSOLE: '/billing/cloud-cost-console',
        COST_EXPLORER: '/billing/cost-explorer',
        DATA_TRANSFER: '/billing/data-transfer',
    },
    SETTINGS: {
        BASE: '/settings',
        USER_MANAGEMENT: '/settings/user-management',
        USER_TAG_MANAGEMENT: '/settings/user-tag-management',
        INVOICE: '/settings/invoice',
        NOTIFICATIONS: '/settings/notifications',
    },
    K8S: {
        BASE: '/k8s',
        CONNECT_K8S_CLUSTER: '/k8s/connect-k8s-cluster',
        GIT_REPO_CONNECTION: '/k8s/Git-repo-connection',
        DEPLOY_TOOLS: '/k8s/Deploy-cloud-analytics-tool',
        DEPLOY_APP_ON_EKS: '/k8s/Deploy-app-on-eks',
        MONITOR_K8S_CLUSTER: '/k8s/Monitor-k8s-cluster',
    }
}